var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dishwasher") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,42 L27,42c-4.418,0-8-3.582-8-8v-8h16v8C35,38.418,31.418,42,27,42z"
  }), /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    x1: 27,
    y1: 42,
    x2: 27,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 50,
    x2: 33,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    x1: 3,
    y1: 18,
    x2: 61,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 58,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,39 c0-2.209-4-8-4-8s-4,5.791-4,8s1.791,4,4,4S50,41.209,50,39z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 54,
    cy: 12,
    r: 2,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.c2f2dbe19e546241a92f2a1e7690bca0.svg";
export { ForwardRef as ReactComponent };